import { Typography } from '@chronosphereio/chrono-ui';
import type { ReactNode } from 'react';

export interface QueryEditorHelpTextProps {
  children: ReactNode;
}

/**
 * Ambient help content rendered outside `Container` as a sibling under `Root`.
 * Use for persistent, neutral information — keyboard shortcuts, docs links,
 * usage hints — that is always visible regardless of editor state.
 *
 * Visually distinct from `Feedback` (which is transient and severity-colored).
 * When both are present, `Feedback` should render above `HelpText`.
 */
export function QueryEditorHelpText({ children }: QueryEditorHelpTextProps) {
  if (!children) return null;

  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', pt: 0.5, textAlign: 'right' }}>
      {children}
    </Typography>
  );
}
